export default {
    state: {
        loading: false, //Used to toggle "progress" cursor style 
        fetching: false, //Used when awaiting fetch from API - Displays spinner overlay
        uploading: false, //Used when uploading via API - Displays spinner overlay
        processingMsg: '', //Used to set a message on the spinner overlay
        error: {
            fatal: ''
        }
    },
    mutations: {
        setFetching: (state, val) => {
            state.fetching = val;
        },
        setUploading: (state, val) => {
            state.uploading = val;
        },
        setLoading: (state, val) => {
            state.loading = val;
        },
        setProcessingMsg: (state, val) => {
            state.processingMsg = val;
        },
        setError: (state, {error, val}) => {
            state.error[error] = val;
        },
    },
    actions: {
        startLoading: ({commit}, ) => {
            commit('setLoading', true);
        },
        endLoading: ({commit}, ) => {
            commit('setLoading', false);
        },
        startFetch: ({commit}, ) => {
            commit('setFetching', true);
        },
        endFetch: ({commit}, ) => {
            commit('setFetching', false);
            commit('setProcessingMsg', '');
        },
        startUpload: ({commit}, ) => {
            commit('setUploading', true);
        },
        endUpload: ({commit}, ) => {
            commit('setUploading', false);
            commit('setProcessingMsg', '');
        },
        resetErrors: ({commit}, ) => {
            commit('setError', {error: 'fatal', val: ''});
        },
        throwErrorFatal: ({commit}, msg) => {
            commit('setError', {error: 'fatal', val: msg});
        }
    },
};